var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Chrome',{attrs:{"value":_vm.value || ''},on:{"input":_vm.updateValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }